<template>
    <asli-popup v-model="displayModal" class="p-4" aria-labelledby="assistance-modal-header" :header="modalHeader" :aria-label="modalHeader">
        <div class="px-8 py-4 flex flex-col gap-y-[15px]">
            <p>
                If you need assistance with using our website or if you require further information on this insurance
                product please contact us on:
            </p>
            <p class="text-center">
                <asli-button
                    id="assistance-modal-call-now"
                    color="primary"
                    type="button"
                    icon="phone"
                    icon-position="left"
                    :href="`tel:${BRAND_PHONE_NUMBER}`"
                >
                    {{ BRAND_PHONE_NUMBER }}
                </asli-button>
            </p>
            <p>
                Alternatively you can visit our
                <a target="_blank" class="text-primary underline" :href="siteLinks.faqs">Help Centre</a>.
            </p>
        </div>
    </asli-popup>
</template>

<script lang="ts" setup>
import { useMainStore } from "@/stores/main";
import { AsliPopup, AsliButton, AsliSectionHeader } from "@mbs-npm/anpost-ui";
import { computed } from "vue";
import { BRAND_PHONE_NUMBER } from "@/static/constants";
import { siteLinks } from "@/utils/links";

const modalHeader = "Need Help?";

const mainStore = useMainStore();

const displayModal = computed({
    get: () => mainStore.displayAdditionalAssistanceModal,
    set: val => (mainStore.displayAdditionalAssistanceModal = val)
});
</script>
